import React from 'react';
import {Menu} from 'semantic-ui-react';
import UserPanel from './UserPanel';
import Channels from './Channels';
import DirectMessages from './DirectMessages';
import Starred from './Starred';
import SkyBg from '../Sky/SkyBg';


class SidePanel extends React.Component {
    render(){
        const {currentUser, primaryColor, emotionProbability} = this.props;
        return(
            <Menu
                size="large"
                inverted
                fixed="left"
                vertical
                style={{background: primaryColor, fontSize: '1.2rem'}}
            >
                <SkyBg emotionProbability={emotionProbability} />
                
                <UserPanel primaryColor={primaryColor} currentUser={currentUser} />
                <Starred currentUser={currentUser} />
                <Channels currentUser={currentUser} />
                <DirectMessages currentUser={currentUser} />
            </Menu>
        )
    }
}

export default SidePanel;


// WEBPACK FOOTER //
// ./src/components/SidePanel/SidePanel.js